<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <Chart />
  </div>
</template>

<script>
// @ is an alias to /src
import Chart from '@/components/Chart.vue'

export default {
  name: 'home',
  components: {
    Chart
  },
  mounted: function() {
    // window.PeBL.user.isLoggedIn(function (isLoggedIn) {
    //     if (!isLoggedIn) {
    //         window.Lightbox.createLoginForm();
    //     }
    // });
  }
}
</script>
